import {
  IndicationStatus,
  InstitutionalIndicationOrderType,
  OrderBookRecordStatus,
} from '../../../../../../../../../graphql';
import {
  UpdateHistory_CoveredIndicationVersionPartsFragment,
  UpdateHistory_IndicationVersionPartsFragment,
  UpdateHistory_MyIndicationVersionPartsFragment,
} from '../../../graphql';

export enum RevisionType {
  Cancelled,
  Deleted,
  Passed,
  Updated,
}

const useGetRevisionType = (
  item:
    | UpdateHistory_IndicationVersionPartsFragment
    | UpdateHistory_CoveredIndicationVersionPartsFragment
    | UpdateHistory_MyIndicationVersionPartsFragment
): RevisionType => {
  if (item.type === InstitutionalIndicationOrderType.Pass) {
    return RevisionType.Passed;
  }

  if (item.status === IndicationStatus.Cancelled) {
    return item.recordStatus === OrderBookRecordStatus.Deleted
      ? RevisionType.Deleted
      : RevisionType.Cancelled;
  }

  return RevisionType.Updated;
};

export default useGetRevisionType;
